import * as React from "react";

export const SvgTwitter = (props) => (
	<svg width={39} height={38} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M27.386 14.446a5.754 5.754 0 0 1-.734.267c.296-.335.522-.73.66-1.16a.245.245 0 0 0-.357-.286 5.773 5.773 0 0 1-1.706.675 3.259 3.259 0 0 0-5.507 2.747 8.333 8.333 0 0 1-5.72-3.035.244.244 0 0 0-.401.031 3.254 3.254 0 0 0-.44 1.637c0 .785.28 1.529.774 2.11a2.757 2.757 0 0 1-.436-.194.245.245 0 0 0-.363.208v.043c0 1.171.63 2.225 1.593 2.8a2.812 2.812 0 0 1-.248-.036.244.244 0 0 0-.278.314 3.254 3.254 0 0 0 2.384 2.182 5.76 5.76 0 0 1-3.078.879c-.23 0-.463-.014-.69-.04a.245.245 0 0 0-.16.448 8.778 8.778 0 0 0 4.746 1.391c3.315 0 5.388-1.562 6.543-2.873 1.441-1.635 2.268-3.799 2.268-5.937 0-.09-.002-.18-.004-.27a6.33 6.33 0 0 0 1.456-1.542.245.245 0 0 0-.302-.36Z"
			fill="#FFB11A"
		/>
		<circle cx={19.5} cy={19} r={18.5} stroke="#FFB11A" />
	</svg>
);
